import type { GarageInput, GarageListQuery, GarageView, Page } from '@chukua/common';
import { api } from '../../../../shared/shared.api';
import { toListParams } from '../../../../shared/policies/list-params';

export type { GarageView };

export function listGarages(query: GarageListQuery): Promise<Page<GarageView>> {
  return api<Page<GarageView>>(`/garages?${toListParams(query)}`);
}

export function createGarage(input: GarageInput): Promise<GarageView> {
  return api<GarageView>('/garages', { method: 'POST', body: JSON.stringify(input) });
}

export function updateGarage(id: string, input: GarageInput): Promise<GarageView> {
  return api<GarageView>(`/garages/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
}

export async function deactivateGarage(id: string): Promise<void> {
  await api<void>(`/garages/${id}/deactivate`, { method: 'POST' });
}

export async function reactivateGarage(id: string): Promise<void> {
  await api<void>(`/garages/${id}/reactivate`, { method: 'POST' });
}
